import React from 'react';
import { StyleSheet, View } from 'react-native';

interface AppDividerProps {
  width?: number;
}
const AppDivider: React.SFC<AppDividerProps> = props => {
  const { width } = props;
  const dividerStyles: any = [styles.divider];
  if (width) {
    dividerStyles.push({ width });
  }

  return <View style={dividerStyles} />;
};

const styles = StyleSheet.create({
  divider: {
    height: 0,
    width: 360,
    marginVertical: 18,
    borderStyle: 'solid',
    borderTopWidth: 1,
    borderTopColor: '#E4E7EC'
  }
});

export default AppDivider;
